module.exports = __webpack_public_path__ + "img/banner_s.8ab4e18a.png";